import { inject } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { take, map, filter, catchError } from 'rxjs/operators';
import * as fromRoot from '../reducers';
import * as olci from '../actions/olci';
import { ResourceBundleService } from '../modules/core/services/resource-bundle.service';

export const contentResolver: ResolveFn<any> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> => {
	const store: Store<fromRoot.AppState> = inject(Store<fromRoot.AppState>);
	const contentService: ResourceBundleService = inject(ResourceBundleService);

	if (!contentService.isPopulated) {
		store.dispatch(new olci.LoadContentAction());
		store.dispatch(new olci.GetCountries());

		return store.pipe(
			select(fromRoot.getContentState),
			filter(content => (content?.contentRetrieval?.resourceBundle ?? content?.error !== null)),
			take(1),
			map(content => {
				if (content.error) {
					throw content.error;
				} else {
					return true;
				}
			}),
			catchError(error => {
				store.dispatch(new olci.NavigateToError());
				return of(false);
			})
		);
	} else {
		return of(true);
	}
}
